export default "__VITE_ASSET__QBrGKnn5__"